import AppConfig from "config";
import axios from "axios";
const jwtToken = localStorage.getItem('access_token');

const LogsController = {
  async ListLogs(page = 1, searchTerm = '') {
    try {
      const response = await axios.get(AppConfig.BACKEND_URL + `/logs?page=${page}&search=${searchTerm}`, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching logs:", error);
      throw error;
    }
  },
};

export default LogsController;
